<template>
  <div class="main-container-l">
    <div class="results-menu-l" v-if="isMobile">
        <ResultsPageRoutes v-on:toggleCalendar="toggleCalendar" v-bind:showCalendar="showCalendar" />
      <Calendar v-show="showCalendar" :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
    </div>
    <div class="loading-container" v-if="offerLoading"><img src="../../assets/img/loading.svg"></div>
    <GamesMenu
    v-if="isMobile && gamesMenuShown"
    v-bind:sports="sports"
    v-bind:sportsselected="sportsselected"
    v-on:selectsport="selectSport"
    v-on:selectcategory="selectCategory"
    v-on:selecttournament="selectTournament"
    v-bind:categoryselected="categoryselected"
    v-bind:tournamentselected="tournamentselected"
    v-bind:offerstate="sportState"
    v-bind:offertree="sportTree"
    v-bind:matchesIn="matchesIn"
    v-on:togglegamesmenu="toggleGamesMenu"
    v-bind:pagetype="'results'" />
    <div class="offer-container-l">
      <GamesMenu
      v-if="!isMobile"
      v-bind:sports="sports"
      v-bind:sportsselected="sportsselected"
      v-on:selectsport="selectSport"
      v-on:selectcategory="selectCategory"
      v-on:selecttournament="selectTournament"
      v-bind:categoryselected="categoryselected"
      v-bind:tournamentselected="tournamentselected"
      v-bind:offerstate="sportState"
      v-bind:offertree="sportTree"
      v-bind:matchesIn="matchesIn"
      v-bind:pagetype="'results'" />
      <div class="group-offer-l" v-on:selectMatch="selectMatch">
        <ResultsPageRoutes v-if="!isMobile" v-on:toggleCalendar="toggleCalendar" v-bind:showCalendar="showCalendar" />
        <div class="group-game-container" v-if="!isMobile">
          <vue-scroll :settings="{wheelPropagation:true}" v-if="selectedMatch && smallDesktop && !isMobile">
            <SportSingleResults :matchesIn="matchesIn" v-on:matchchange="matchChange" />
          </vue-scroll>
          <TournamentsResults
          v-if="!smallDesktop || (smallDesktop && !selectedMatch)"
          v-bind:matchesIn="matchesIn"
          v-bind:categoriesin="categoriesin"
          v-bind:tournamentsin="tournamentsin"
          v-bind:sportsselected="sportsselected"
          v-bind:categoryselected="categoryselected"
          v-bind:tournamentselected="tournamentselected"
          v-bind:offerLoading="offerLoading"/>
        </div>
        <!-- Mobile Tournaments and Selected Match -->
        <TournamentsResults
        v-if="isMobile && !selectedMatch"
        v-bind:matchesIn="matchesIn"
        v-bind:categoriesin="categoriesin"
        v-bind:tournamentsin="tournamentsin"
        v-bind:sportsselected="sportsselected"
        v-bind:categoryselected="categoryselected"
        v-bind:tournamentselected="tournamentselected"
        v-bind:offerLoading="offerLoading"/>
      </div>
      <div class="single-offer-l" v-if="selectedMatch && !isMobile && !smallDesktop">
        <div class="single-games-box">
          <vue-scroll :settings="{wheelPropagation:true}">
            <SportSingleResults :matchesIn="matchesIn" v-on:matchchange="matchChange" />
          </vue-scroll>
        </div>
      </div>
    </div>
    <div class="results-menu-l" v-if="!isMobile">
      <div class="results-menu-subcontainer">
        <Calendar :otherStartDate="startDate" v-on:selectDate="changeDate"></Calendar>
      </div>
    </div>
  </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';
import moment from 'moment-timezone';
import GamesMenu from './containers/GamesMenu.vue';
import TournamentsResults from './containers/TournamentsResults.vue';
import SportSingleResults from './containers/SportSingleResults.vue';
import Calendar from '../components/Calendar.vue';
import ResultsPageRoutes from './containers/ResultsPageRoutes.vue';

export default {
    name: 'SportResults',
    components:
  {
      ResultsPageRoutes,
      GamesMenu,
      TournamentsResults,
      SportSingleResults,
      Calendar,

  },
    data()
    {
        return {
            expandedMenu: true,
            searchBox: false,
            oddSelectBox: false,

            sporttree: {},
            sportsin: {},
            categoriesin: {},
            tournamentsin: {},
            sportsselected: [],
            categoryselected: [],
            tournamentselected: [],

            socketParams: false,
            searchparam: '',
            hasVisualization: false,
            openstreamsingle: false,
            showSuperSixOdds: false,
            gamesMenuShown: true,
            showCalendar: false,
            matchesIn: {},
            startDate: moment().set({ hours: 0, minutes: 0, seconds: 0 }),
            offerLoading: true,
            initialLoad: true,
            sportState: false,
            selectedMatch: null,
            sportsLoaded: false,
        };
    },
    async created()
    {
        const me = this;

        me.selectMatch(null);
        await me.initSportTree();
    },
    methods: {
        ...mapActions([
            'setTree',
        ]),
        changeDate(val)
        {
            const me = this;
            me.startDate = val;
        },
        async initSportTree()
        {
            const me = this;

            await me.setTree();

            me.getResultsByDate();
        },
        toggleCalendar()
        {
            const me = this;
            me.showCalendar = !me.showCalendar;
        },
        toggleGamesMenu()
        {
            const me = this;
            me.gamesMenuShown = !me.gamesMenuShown;
        },
        selectSport(val)
        {
            const me = this;
            if (me.smallDesktop)
            {
                me.selectMatch(null);
            }
            me.sportsselected = val;
            me.categoryselected = [];
            me.tournamentselected = [];
        },
        selectCategory(val)
        {
            const me = this;
            if (me.smallDesktop)
            {
                me.selectMatch(null);
            }
            me.sportsselected = [val.sportId];
            me.categoryselected = [val.categoryId];
            me.tournamentselected = [];
        },
        selectTournament(val)
        {
            const me = this;
            if (me.smallDesktop)
            {
                me.selectMatch(null);
            }
            me.sportsselected = [val.sportId];
            me.categoryselected = [val.categoryId];
            me.tournamentselected = [val.tournamentId];
        },
        async getResultsByDate()
        {
            const me = this;

            if (!me.initialLoad && (me.startDate === false || me.offerLoading === true))
            {
                return;
            }

            me.initialLoad = false;

            me.matchesIn = { };
            me.sportsin = {};
            me.categoriesin = {};
            me.tournamentsin = {};
            me.sportsselected = [];
            me.categoryselected = [];
            me.tournamentselected = [];
            me.sportsLoaded = false;
            me.selectMatch(null);

            let startDate = moment(me.startDate).set({ hours: 0, minutes: 0, seconds: 0 });
            startDate = moment.utc(startDate).format('YYYY-MM-DD HH:mm:ss');

            let endDate = moment(me.startDate).add(1, 'day').set({ hours: 0, minutes: 0, seconds: 0 });
            endDate = moment.utc(endDate).format('YYYY-MM-DD HH:mm:ss');

            const params = {
                status: 'finished',
                minoffer: '1',
                startDate,
                endDate,
            };

            me.offerLoading = true;

            const data = await me.offerHandling.callOffer(
                `/${me.globals.langCode}/sport/getOffer`,
                params,
            );

            const matchesSorted = data.data;

            const matchesTemp = {};

            for (const match of matchesSorted)
            {
                matchesTemp[match.matchId] = match;
            }

            me.matchesIn = { ...matchesTemp };

            me.$nextTick(() =>
            {
                me.offerLoading = false;
            });

            me.showCalendar = false;
        },
        selectMatch(matchId)
        {
            const me = this;

            me.selectedMatch = matchId;
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'smallDesktop',
            'offerHandling',
            'offerStructLoaded',
            'sportTree',
            'resultsAvailable',
        ]),
        sports()
        {
            const me = this;

            const sports = [];
            for (const key in me.sportsin)
            {
                if (me.sportsin[key] !== undefined)
                {
                    const categories = [];
                    const { sportId } = me.sportsin[key];

                    for (const keyCat in me.categoriesin[sportId])
                    {
                        if (me.categoriesin[sportId][keyCat] !== undefined)
                        {
                            const cat = me.categoriesin[sportId][keyCat];

                            const { categoryId } = cat;

                            const tournaments = [];
                            for (const keyTour in me.tournamentsin[categoryId])
                            {
                                if (me.tournamentsin[categoryId][keyTour] !== undefined)
                                {
                                    const tour = me.tournamentsin[categoryId][keyTour];
                                    tournaments.push(tour);
                                }
                            }

                            tournaments.stableSort((a, b) =>
                            {
                                if (a.tournamentOrder < b.tournamentOrder)
                                {
                                    return -1;
                                }

                                if (a.tournamentOrder > b.tournamentOrder)
                                {
                                    return 1;
                                }

                                return 0;
                            });

                            cat.tournaments = tournaments;

                            categories.push(cat);
                        }
                    }

                    categories.sort((a, b) =>
                    {
                        if (me.sportTree.categories[a.categoryId].categoryOrder
                        < me.sportTree.categories[b.categoryId].categoryOrder)
                        {
                            return -1;
                        }

                        if (me.sportTree.categories[a.categoryId].categoryOrder
                        > me.sportTree.categories[b.categoryId].categoryOrder)
                        {
                            return 1;
                        }

                        return 0;
                    });

                    me.sportsin[key].categories = categories;

                    sports.push(me.sportsin[key]);
                }
            }

            sports.stableSort((a, b) =>
            {
                if (a.sportOrder < b.sportOrder)
                {
                    return -1;
                }

                if (a.sportOrder > b.sportOrder)
                {
                    return 1;
                }

                return 0;
            });
            if (!me.sportsLoaded && sports.length > 0)
            {
                me.sportsselected = [sports[0].sportId];
                me.sportsLoaded = true;
            }

            return sports;
        },
    },
    watch:
    {
        isMobile(val)
        {
            const me = this;
            if (val && me.selectedMatch != null)
            {
                me.$router.push({ path: `/results/sport/${me.selectedMatch}` });
            }
        },
        smallDesktop(val)
        {
            const me = this;

            if (!me.isMobile)
            {
                if (val)
                {
                    me.selectMatch(null);
                }
            }
        },
        matchesIn:
        {
            handler()
            {
                const me = this;

                me.sportsin = {};
                me.categoriesin = {};
                me.tournamentsin = {};

                for (const matchId in me.matchesIn)
                {
                    if (me.matchesIn[matchId] !== undefined)
                    {
                        const match = me.matchesIn[matchId];

                        if (typeof me.sportsin[match.sportId] === 'undefined')
                        {
                            me.sportsin[match.sportId] = {
                                sportName: me.sportTree.sports[match.sportId].sportName,
                                sportOrder: me.sportTree.sports[match.sportId].sportOrder,
                                sportId: match.sportId,
                                matchesNum: 0,
                                matches: [],
                            };
                        }

                        me.sportsin[match.sportId].matchesNum += 1;
                        me.sportsin[match.sportId].matches.push(match);

                        if (typeof me.categoriesin[match.sportId] === 'undefined')
                        {
                            me.categoriesin[match.sportId] = {};
                        }

                        if (typeof me.categoriesin[match.sportId][match.categoryId] === 'undefined')
                        {
                            me.categoriesin[match.sportId][match.categoryId] = {
                                categoryName: me.sportTree.categories[match.categoryId].categoryName,
                                categoryOrder: me.sportTree.categories[match.categoryId].categoryOrder,
                                categoryId: match.categoryId,
                                matchesNum: 0,
                            };
                        }

                        me.categoriesin[match.sportId][match.categoryId].matchesNum += 1;

                        if (typeof me.tournamentsin[match.categoryId] === 'undefined')
                        {
                            me.tournamentsin[match.categoryId] = {};
                        }

                        if (typeof me.tournamentsin[match.categoryId][match.tournamentId] === 'undefined')
                        {
                            me.tournamentsin[match.categoryId][match.tournamentId] = {
                                tournamentName: me.sportTree.tournaments[match.tournamentId].tournamentName,
                                tournamentId: match.tournamentId,
                                tournamentOrder: me.sportTree.tournaments[match.tournamentId].tournamentOrder,
                                matchesNum: 0,
                            };
                        }

                        me.tournamentsin[match.categoryId][match.tournamentId].matchesNum += 1;
                    }
                }

                for (const sportTemp in me.sportsin)
                {
                    if (me.sportsin[sportTemp] !== undefined)
                    {
                        me.sportsin[sportTemp].matches.stableSort((a, b) =>
                        {
                            if (me.sportTree.tournaments[a.tournamentId].tournamentOrder
                            < me.sportTree.tournaments[b.tournamentId].tournamentOrder)
                            {
                                return -1;
                            }

                            if (me.sportTree.tournaments[a.tournamentId].tournamentOrder
                            > me.sportTree.tournaments[b.tournamentId].tournamentOrder)
                            {
                                return 1;
                            }

                            return 0;
                        });

                        me.sportsin[sportTemp].matches.stableSort((a, b) =>
                        {
                            if (me.sportTree.categories[a.categoryId].categoryName
                            < me.sportTree.categories[b.categoryId].categoryName)
                            {
                                return -1;
                            }

                            if (me.sportTree.categories[a.categoryId].categoryName
                            > me.sportTree.categories[b.categoryId].categoryName)
                            {
                                return 1;
                            }

                            return 0;
                        });

                        me.sportsin[sportTemp].matches.stableSort((a, b) =>
                        {
                            if (me.sportTree.categories[a.categoryId].categoryOrder
                            < me.sportTree.categories[b.categoryId].categoryOrder)
                            {
                                return -1;
                            }

                            if (me.sportTree.categories[a.categoryId].categoryOrder
                            > me.sportTree.categories[b.categoryId].categoryOrder)
                            {
                                return 1;
                            }

                            return 0;
                        });
                    }
                }

                me.sportsin = {
                    ...me.sportsin,
                };
                me.categoriesin = {
                    ...me.categoriesin,
                };
                me.tournamentsin = {
                    ...me.tournamentsin,
                };
            },
            deep: true,
        },
        startDate(val)
        {
            const me = this;
            if (val === false)
            {
                return;
            }

            me.getResultsByDate();
        },
    },
};
</script>
